export default "__VITE_ASSET__BfGnYG5O__"